import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.kissorder').factory('OrdersSvc', OrdersSvc);

    OrdersSvc.$inject = ['OrdersDA', 'OrderFilter'];

    function OrdersSvc(OrdersDA, OrderFilter) {
        var exports = {
            searchOrders: searchOrders,
            searchOrderByGuid: searchOrderByGuid,
            getInvoicesAssociated: getInvoicesAssociated
        };

        return exports;

        ////////////////

        /**
         * Recherche les commandes suivant des critères
         * @param filter Critères de recherches
         */
        function searchOrders(filter) {
            return OrdersDA.searchOrders(filter);
        }

        /**
         * Recherche une commande à partir de son guid.
         * @param guid de la commande
         */
        function searchOrderByGuid(guid, loadOptions) {
            var orderFilter = new OrderFilter();
            orderFilter.setGuid(guid);
            orderFilter.setDocumentOptions(loadOptions);
            return OrdersDA.searchOrders(orderFilter);
        }

        /**
         * Récupère les factures créées à partir d'une commande.
         * guid Guid de la commande
         */
        function getInvoicesAssociated(guid) {
            return OrdersDA.getInvoicesAssociated(guid);
        }
    }
})();
